import { Injectable } from '@angular/core';

@Injectable()
export class StaticPathUtil {
  private PERSON_IMG_PATH = 'https://static-resource.nv.at/media/200/';
  private PERSON_IMG_FALLBACK = './assets/Berater.svg';
  private IC_URL_POL = 'nvic:show/polints/';
  private IC_URL_SCHADEN = 'nvic:show/schints/';
  private O30_URL_DEV = 'https://ds310.nv.at';
  private ARCHIVCLIENT_URL = 'nvcockpit:opendoc:';
  private LOCAL_PRINT_URL = 'nvcockpit:addruck:[url]:[polint]';

  public getPersonImgPath(): string {
    return this.PERSON_IMG_PATH;
  }

  public getInfoClientURLPol(): string {
    return this.IC_URL_POL;
  }

  public getInfoClientURLSchaden(): string {
    return this.IC_URL_SCHADEN;
  }

  public getFallbackPath(): string {
    return this.PERSON_IMG_FALLBACK;
  }

  public getO30UrlFallbackDevUrl(): string {
    return this.O30_URL_DEV;
  }

  public getArchivClientUrl(): string {
    return this.ARCHIVCLIENT_URL;
  }

  public getLocalPrintUrl(polint: string): string {
    const x = this.LOCAL_PRINT_URL.replace('[url]', window.location.hostname).replace('[polint]', polint);
    console.log('local print url:; ' + x);
    return x;
  }
}
